import React, { memo } from 'react'
import { getFAQ } from './FaqHelper'
import CruiseFAQSection from './CruiseFAQSection'
interface Props {
  cruiseLine: App.CruiseLine
  ship: App.CruiseShip
}

function CruiseFAQ({ cruiseLine, ship }: Props) {
  const faq = getFAQ(cruiseLine, ship)

  return (
    <>
      {faq.map((faqSection, index) => (
        <CruiseFAQSection key={index} FAQItem={faqSection} />
      ))}
    </>
  )
}

export default memo(CruiseFAQ)
